module.exports = __webpack_public_path__ + "static/assets/dac921caa8b77799eefc0293cd6b315a.svg";